import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { sendPlaylistEvent } from '../../utils/playlistEvents';

export default function CTABlock({ block, playlist, blockIndex, onComplete }) {
  const [watchStartTime] = useState(Date.now());
  const buttonText = block.props?.button_text || 'Learn More';
  const buttonUrl = block.props?.button_url || '#';
  const heading = block.props?.heading || '';
  const description = block.props?.description || '';

  useEffect(() => {
    sendPlaylistEvent(playlist.id, 'block_start', {
      block_id: block.id,
      block_index: blockIndex,
      block_type: 'cta'
    });

    // Auto-complete CTA block after 3 seconds (giving time to read)
    const timer = setTimeout(() => {
      sendPlaylistEvent(playlist.id, 'block_complete', {
        block_id: block.id,
        block_index: blockIndex,
        watch_ms: Date.now() - watchStartTime
      });
      if (onComplete) onComplete();
    }, 3000);

    return () => clearTimeout(timer);
  }, [block.id, blockIndex, onComplete, playlist.id, watchStartTime]);

  const handleCTAClick = () => {
    sendPlaylistEvent(playlist.id, 'cta_click', {
      block_id: block.id,
      block_index: blockIndex,
      url: buttonUrl,
      label: buttonText
    });
    if (buttonUrl && buttonUrl !== '#') {
      window.open(buttonUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="relative w-full h-full bg-gradient-to-br from-orange-900 to-red-900 flex items-center justify-center p-8">
      <div className="text-center max-w-2xl">
        {heading && (
          <h2 className="text-white text-3xl md:text-5xl font-bold mb-4">{heading}</h2>
        )}
        
        {description && (
          <p className="text-white/90 text-lg md:text-xl mb-8">{description}</p>
        )}

        <Button
          onClick={handleCTAClick}
          size="lg"
          className="bg-white text-black hover:bg-gray-200 text-lg px-8 py-6"
        >
          <ExternalLink className="h-6 w-6 mr-2" />
          {buttonText}
        </Button>
      </div>
    </div>
  );
}
